var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiSuggestionWhite = function SvgAiSuggestionWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-suggestion-white_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-suggestion-white_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71 3.174a.38.38 0 0 1 .712 0l.609 1.645a.38.38 0 0 0 .224.225l1.645.608a.38.38 0 0 1 0 .712l-1.645.61a.38.38 0 0 0-.224.223l-.609 1.646a.38.38 0 0 1-.712 0L4.1 7.197a.38.38 0 0 0-.224-.224l-1.645-.609a.38.38 0 0 1 0-.712l1.645-.608a.38.38 0 0 0 .224-.225l.609-1.645Z",
    fill: "#fff",
    fillOpacity: 0.75,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-suggestion-white_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.016 6.338a.253.253 0 0 1 .475 0l.406 1.097c.025.069.08.123.15.149l1.096.406c.22.081.22.393 0 .475l-1.097.405a.253.253 0 0 0-.15.15l-.405 1.097a.253.253 0 0 1-.475 0L19.61 9.02a.253.253 0 0 0-.15-.15l-1.096-.405a.253.253 0 0 1 0-.475l1.097-.406a.253.253 0 0 0 .15-.15l.405-1.096Z",
    fill: "#fff",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-suggestion-white_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.521 18.197a.19.19 0 0 1 .356 0l.304.823a.19.19 0 0 0 .113.112l.822.304a.19.19 0 0 1 0 .356l-.822.304a.19.19 0 0 0-.113.113l-.304.822a.19.19 0 0 1-.356 0l-.304-.822a.19.19 0 0 0-.113-.113l-.822-.304a.19.19 0 0 1 0-.356l.822-.304a.19.19 0 0 0 .113-.113l.304-.822Z",
    fill: "#fff",
    fillOpacity: 0.35,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ai-suggestion-white_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.851 6.314c.255-.688 1.229-.688 1.484 0l1.268 3.428a.79.79 0 0 0 .467.467l3.427 1.268c.689.255.689 1.229 0 1.484l-3.427 1.268a.79.79 0 0 0-.467.467l-1.268 3.427c-.255.689-1.23.689-1.484 0l-1.268-3.427a.79.79 0 0 0-.467-.467L5.688 12.96c-.688-.255-.688-1.23 0-1.484l3.428-1.268a.79.79 0 0 0 .467-.467l1.268-3.428Z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ai-suggestion-white_svg__b",
    x: -16.016,
    y: -12.074,
    width: 42.164,
    height: 42.165,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3442_346599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3442_346599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai-suggestion-white_svg__c",
    x: 0.199,
    y: -8.827,
    width: 40.109,
    height: 40.109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3442_346599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3442_346599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai-suggestion-white_svg__d",
    x: -13.842,
    y: 3.073,
    width: 39.082,
    height: 39.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3442_346599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3442_346599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ai-suggestion-white_svg__e",
    x: -12.828,
    y: -9.202,
    width: 48.842,
    height: 48.842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3442_346599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3442_346599",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-suggestion-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAiSuggestionWhite;